import "./_cardProduct.scss";

import cx from "classnames";
import {ReactNode} from "react";
import {useNavigate} from "react-router-dom";

import iconNoPicture from "@/assets/massification/iconNoPicture.png";
import LineInfo from "@/components/LineInfo/LineInfo";
import {OffreType} from "@/ts/interface/offres";
import {defaultConfig, offerConfigMap} from "@/ts/interface/offres";

import {CardProduct as CardProductInterface} from "./interface";

function CardProduct({
  product,
  offreType,
  offre_id,
  children,
  small = false,
}: {
  product: CardProductInterface;
  offreType?: OffreType;
  offre_id: number | string;
  children?: ReactNode;
  small?: boolean;
}): JSX.Element {
  const {article_id, nom, gencod, code_catalogue, photos, reference} = product;

  const {color, message} =
    offerConfigMap[offreType as OffreType] || defaultConfig;

  const navigate = useNavigate();

  const handleClick = (): void => {
    navigate({
      pathname: "/co-deals/detail_massification",
      search: `?article_id=${article_id}&offre_id=${offre_id}`,
    });
  };
  if (small) {
    return (
      <article
        className={cx("cardProduct", color, "smallCardProduct")}
        onClick={handleClick}>
        <h3 className="responsive-title">{nom}</h3>
        <div className="cardProduct-content">
          <img
            src={photos?.[0] || iconNoPicture}
            alt={`photo du produit ${nom}`}
          />
          <div className="cardProduct-content--data">
            <h3>{nom}</h3>
          </div>
        </div>
      </article>
    );
  }
  return (
    <article
      className={cx("cardProduct", color, small ? "smallCardProduct" : "")}
      onClick={handleClick}>
      <h3 className="responsive-title">{nom}</h3>
      <div className="cardProduct-content">
        <img
          src={photos?.[0] || iconNoPicture}
          alt={`photo du produit ${nom}`}
        />
        <div className="cardProduct-content--data">
          <h3>{nom}</h3>
          <div className="cardProduct-content--info">
            <div>
              <LineInfo label="Gencod" value={gencod} />
            </div>
            <div>
              <LineInfo label="Reference" value={reference} />
              <LineInfo label="Code catalogue" value={code_catalogue} />
            </div>
          </div>
          <div className="cardProduct-content--children">{children}</div>
        </div>
      </div>
      <div className="responsive-cardProduct--children">{children}</div>
      {message ? (
        <div className="cardProduct-footer">
          <p>{message}</p>
        </div>
      ) : null}
    </article>
  );
}

export default CardProduct;
